import { css } from '@emotion/react'
import { Flow, Icon, Paper, Text, Theme, useTheme } from 'bold-ui'
import { TipoImovelEnum } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'
import { getImovelCepFormatado } from 'view/visualizacaoTerritorial/utils/visualizacaoTerritorialUtils'

import { tipoImovelRecord } from '../../model'
import { getNumeroMoradoresFormatado } from '../formatters-territorioMapa'
import { TerritorioPinoModel } from '../model-territorioMapa'

interface MapaTerritorioMarkerCardProps {
  imovel: TerritorioPinoModel
}

export function MapaTerritorioMarkerCard(props: Readonly<MapaTerritorioMarkerCardProps>) {
  const { imovel } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  const tipoImovelDescricao = tipoImovelRecord[imovel.tipoImovel ?? TipoImovelEnum.OUTROS].tooltip
  const hasNumeroMoradores = !isUndefinedOrNull(imovel.numeroMoradores)

  return (
    <Paper elevation={40} style={styles.card}>
      <Text variant='h3' style={styles.wrap}>
        {formatLogradouro(imovel)}
      </Text>
      <Text fontSize={1} style={styles.wrap}>
        {formatBairroCepComplemento(imovel)}
      </Text>
      <Flow direction='horizontal' alignItems='center' gap={1}>
        <Text color='secondary' fontSize={1}>
          {tipoImovelDescricao}
        </Text>

        {hasNumeroMoradores && (
          <Flow direction='horizontal' alignItems='center' gap={0.5}>
            <Icon icon='userFilled' size={1.25} color={theme.pallete.text.secondary} />
            <Text color='secondary' fontSize={1}>
              {getNumeroMoradoresFormatado(imovel.numeroMoradores)}
            </Text>
          </Flow>
        )}
      </Flow>
    </Paper>
  )
}

function formatLogradouro(imovel: TerritorioPinoModel): string {
  const logradouro = [imovel.tipoLogradouro?.nome, imovel.logradouro].filter(Boolean).join(' ').titleCase()
  return [logradouro, imovel.semNumero ? 'S/N' : imovel.numero].filter(Boolean).join(', ') || 'Sem Endereço'
}

function formatBairroCepComplemento(imovel: TerritorioPinoModel): string {
  const cep = getImovelCepFormatado(imovel.cep, false) as string
  const bairroECep = [imovel.bairro?.titleCase(), cep].filter(Boolean).join(', ')

  return [imovel.complemento?.titleCase(), bairroECep].filter(Boolean).join(' | ') || '-'
}

const createStyles = (theme: Theme) => ({
  card: css`
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    width: 20rem;
    padding: 0.5rem 1rem;
    border: 0;
    border-radius: ${theme.radius.popper}px;
    background-color: ${theme.pallete.surface.main};
  `,
  wrap: css`
    white-space: normal;
    overflow-wrap: anywhere;
  `,
})
